import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import themeStyle from "../../assets/jss/eclipse/components/themeStyle.js";
import { loginToApp, logoutFromApp } from "../../redux-services/actions/actions.js";
import Button from "../../components/CustomButtons/Button.js";
import { SpinnerComponent } from "react-element-spinner";
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { DCustomerManagementApi } from "eclipse-react-sdk/services";
import { primaryColor, disabledCardBackgroundColor } from "../../style.scss";
import AlertNotification from "../../components/Snackbar/AlertNotification.js";
import { EnvConfig } from "../../environment.js";
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { ReactComponent as Info } from "../../assets/img/info.svg";
import { grayColor, whiteColor } from "../../assets/jss/eclipse.js";
import { ReturnStoredTemplateId } from "../../get-template-hostname.js";
// import { AuthRouteWithTemplateId } from "../../default-route.js";
import Dialog from '@material-ui/core/Dialog';
import { EclipseCustomerStatus, EclipseTitle } from "eclipse-react-sdk/services/models";
import TextField from "@material-ui/core/TextField";
import Danger from "../../components/Typography/Danger";
import formStyle from "../../assets/jss/eclipse/components/formStyle";
import EditIcon from '@material-ui/icons/Edit';
import MenuItem from '@material-ui/core/MenuItem';
import { getLoginChallenge, loginWithWebAuthn, verifyLoginChallenge } from '../../views-auth/Login/webauthn/webauthn.helper'
import { platformAuthenticatorIsAvailable, browserSupportsWebAuthn } from '@simplewebauthn/browser';
import { ReactComponent as BiometricErrorIcon } from '../../assets/img/biometric-error-icon.svg'
import { ReactComponent as BiometricSuccessIcon } from '../../assets/img/BiometricSuccess.svg'
import { ReactComponent as ToolTipIcon } from '../../assets/img/circle_tick_success.svg'
import Switch from '@material-ui/core/Switch';
import { FormControlLabel } from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';
import { primaryIconColor } from "../../style.scss";


const ValidationTextField = withStyles(formStyle)(TextField);

const useStyles = makeStyles(themeStyle);

const usePopOverStyles = makeStyles(() => ({
  typography: {
    padding: '0 1em 1em 1em',
    fontSize: '0.9em'
  },
}));

export function UserProfile(props) {
  const appData = props?.appData;
  const tenantId = appData?.auth?.tenantId;
  const customer = appData?.customer;
  const userId = customer?.customerId;
  const template = appData?.template;
  const pwaAppOptions = template?.pwaAppOptions;
  const isKYCRequired = pwaAppOptions?.kycRequired;
  const postSuccessKYCProcessEnable = pwaAppOptions?.postSuccessKYCProcessEnable;
  const passwordPINText = pwaAppOptions?.passwordPINText;
  const identityPrefix = template?.identityPrefix;
  const userIdentity = appData?.identity;
  const history = useHistory();
  const classes = useStyles();
  const classesPopOver = usePopOverStyles();

  const titleEnumList = Object.values(EclipseTitle);
  const [isActive, setActive] = React.useState(false);
  const [webauthnActivate, setWebauthnActivate] = React.useState(false);
  const [popoverAnchorEl, setPopoverAnchorEl] = React.useState(null);
  const [editTitle, setEditTitle] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [openWebAuthnSupportDialog, setOpenWebAuthnSupportDialog] = useState(false);
  const [openWebAuthnErrorDialog, setOpenWebAuthnErrorDialog] = useState(false);
  const [openWebAuthnConfirmDialog, setOpenWebAuthnConfirmDialog] = useState(false);
  const [openWebAuthnRegisterErrorDialog, setOpenWebAuthnRegisterErrorDialog] = useState(false);
  const [isWebAuthNAvailable, setIsWebAuthNAvailable] = useState(false);
  const [openWebAuthnSuccessDialog, setOpenWebAuthnSuccessDialog] = useState(false);
  const [inputs, setInputs] = useState({ title: customer?.title, email: customer?.email });
  const [errors, setErrors] = useState({});

  const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 44,
      height: 24,
      padding: 0,
      overflow: "inherit"
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(18px)',
        color: whiteColor,
        '& + $track': {
          opacity: 1,
          borderColor: primaryColor,
        },
      },
      '&$focusVisible $thumb': {
        color: primaryColor,
      },
    },
    thumb: {
      width: 24,
      height: 24,
      backgroundColor: whiteColor,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${disabledCardBackgroundColor}`,
      backgroundColor: disabledCardBackgroundColor,
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
  });

  const toggleChecked = (event) => {
    event.persist();
    setWebauthnActivate(event.target.checked);
    setOpenWebAuthnConfirmDialog(true);
  }

  const handleInputChange = (event) => {
    event.persist();
    inputs[event.target.name] = event.target.value;
    setInputs(inputs);
    const validationErrors = validateEditTitleEmailForm(inputs, event.target.name);
    setErrors(validationErrors);
  }

  const handleInputKeyUp = (event) => {
    event.persist();
    const validationErrors = validateEditTitleEmailForm(inputs, event.target.name);
    setErrors(validationErrors);
  }

  const closeDialog = () => {
    setOpenWebAuthnSupportDialog(false);
    setOpenWebAuthnErrorDialog(false);
    setOpenWebAuthnRegisterErrorDialog(false);
    setOpenWebAuthnConfirmDialog(false);
  };

  const validateEditTitleEmailForm = (inputs, controlName) => {
    const errors = {}
    if (controlName === 'title') {
      if (!inputs.title) {
        errors.title = `Title required!`;
      }
    }

    if (controlName === 'email') {
      if (!inputs.email) {
        errors.email = `Email required!`;
      } else if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i.test(inputs.email)) {
        errors.email = `Invalid Email!`;
      }
    }

    return errors;
  }

  const cancelChanges = (controlName) => {
    setInputs({ title: customer?.title, email: customer?.email });
    setErrors({});
    if (controlName === 'title') {
      setEditTitle(false);
    }
    if (controlName === 'email') {
      setEditEmail(false);
    }
  }

  const handlePopoverClick = (event) => {
    setPopoverAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setPopoverAnchorEl(null);
  };

  const popoverOpen = Boolean(popoverAnchorEl);
  const popoverId = popoverOpen ? 'simple-popover' : undefined;

  const [documents, setDocuments] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [isRatifiedSuccess, setRatify] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [isProfileLoading, setProfileLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [alertData, setAlert] = useState(null);

  const showAlert = (alertDisplay, alertType, alertMessage) => {
    setAlert({ alertDisplay, alertType, alertMessage })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
  }

  const backToHome = useCallback(() => {
    const appData = {
      ...props?.appData,
      isRefresh: true
    }
    props.userProfileHandler(appData);
    history.push({
      pathname: '/pages/dashboard',
    });
  }, [history, props])

  const logout = () => {
    let templateId = appData?.templateId ? appData?.templateId : ReturnStoredTemplateId();
    if (!templateId) {
      templateId = 'default';
    }
    EnvConfig().BASE_API_URL = template?.defaultBaseURL;
    props.logoutFromAppHandler({ templateId });
    // history.push(`${AuthRouteWithTemplateId('login')}`);
  }

  const redirectToChangePasswordPIN = () => {
    history.push({
      pathname: '/pages/change-password',
    });
  }

  const deactivateAccount = () => {
    setConfirmOpen(true);
  }

  const removeWebAuthIdentity = async () => {
    setOpenWebAuthnConfirmDialog(false);
    setLoading(true);
    const customerAPI = new DCustomerManagementApi();
    const identity = `${identityPrefix}WEBAUTH-${userIdentity}`;
    return customerAPI.tenantsTenantIdCustomersCustomerIdIdentitiesIdentityDelete(tenantId, userId, identity).then(async ({ data }) => {
      setActive(false);
      setLoading(false);
    }).catch(async (error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen(`/pages/user`, `/pages/error`);
      }
    });
  }

  const saveWebAuthIdentity = async () => {
    const customerAPI = new DCustomerManagementApi();
    const createIdentityBody = {
      identity: `${identityPrefix}WEBAUTH-${userIdentity}`,
    }
    return customerAPI.tenantsTenantIdCustomersCustomerIdIdentitiesPost(tenantId, userId, createIdentityBody).then(async ({ data }) => {
      return { data }
    }).catch(async (error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen(`/pages/user`, `/pages/error`);
      }
    });
  }

  const activateWebauthn = async () => {
    if ((isWebAuthNAvailable && browserSupportsWebAuthn())) {
      await getLoginChallenge(`${identityPrefix}WEBAUTH-${userIdentity}`)
        .then(async (challenge) => {
          await verifyLoginChallenge(challenge).then(async (result) => {
            setLoading(true);
            await loginWithWebAuthn({ ...result, identity: `${identityPrefix}WEBAUTH-${userIdentity}` }).then(() => {
              setOpenWebAuthnConfirmDialog(false);
              setOpenWebAuthnSuccessDialog(true);
              setActive((prev) => !prev);
            }).catch(error => {
              setLoading(false);
              if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
                showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
              } else {
                redirectToErrorScreen(`/pages/user`, `error`);
              }
            });
          }).catch((error) => {
            setOpenWebAuthnErrorDialog(true);
          })
        }).catch(async (error) => {
          if (error?.response?.status === 403) {
            await saveWebAuthIdentity().then(() => {
              activateWebauthn();
            });
          } else {
            setOpenWebAuthnErrorDialog(true);
          }
        });
    } else {
      setOpenWebAuthnSupportDialog(true);
    }
  }


  const handleDeactivate = () => {
    setConfirmOpen(false);
    setLoading(true);
    const customerAPI = new DCustomerManagementApi();
    const customerBody = {
      ...customer,
      status: EclipseCustomerStatus.INACTIVE
    };
    customerAPI.tenantsTenantIdCustomersCustomerIdPut(tenantId, customer?.customerId, customerBody).then((customerApiResponse) => {
      props.appData.customer = customerApiResponse.data;
      props.appData.isRefresh = true;
      props.userProfileHandler({ ...props.appData });
      history.push({
        pathname: "/pages/success-account-deactivate"
      })
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/user', '/pages/error');
      }
    });
  }

  const handleClose = () => {
    setConfirmOpen(false);
  };

  const redirectToErrorScreen = useCallback((fromScreen, toScreen) => {
    history.push({
      pathname: toScreen,
      state: { fromScreen: fromScreen }
    });
  }, [history]);

  const getAddress = useCallback(() => {
    setLoading(true);
    const addressAPI = new DCustomerManagementApi();
    addressAPI.tenantsTenantIdCustomersCustomerIdAddressesGet(tenantId, customer?.customerId).then((addressAPIResponse) => {
      setAddresses(addressAPIResponse.data && addressAPIResponse.data.length > 0 ? addressAPIResponse.data : [])
      setLoading(false);
      if (addressAPIResponse.data && addressAPIResponse.data.length < 1) {
        showAlert(true, 'ERROR', `Address(s) not found!`);
      }
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/user', '/pages/error');
      }
    });
  }, [tenantId, customer, redirectToErrorScreen]);

  const getDocuments = useCallback(() => {
    setLoading(true);
    const documentAPI = new DCustomerManagementApi();
    documentAPI.tenantsTenantIdCustomersCustomerIdDocumentsGet(tenantId, customer?.customerId).then((documentAPIResponse) => {
      setDocuments(documentAPIResponse.data && documentAPIResponse.data.length > 0 ? documentAPIResponse.data : [])
      setLoading(false);
      if (documentAPIResponse.data && documentAPIResponse.data.length < 1) {
        showAlert(true, 'ERROR', `Document(s) not found!`);
      }
      getAddress();
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/user', '/pages/error');
      }
    });
  }, [tenantId, customer, redirectToErrorScreen, getAddress]);

  const getRatify = useCallback(() => {
    setLoading(true);
    const ratifyAPI = new DCustomerManagementApi();
    ratifyAPI.tenantsTenantIdCustomersCustomerIdWalletTypesGet(tenantId, customer?.customerId, 1, 0).then((ratifyAPIResponse) => {
      if (ratifyAPIResponse.data && ratifyAPIResponse.data.length > 0) {
        let isRatifyFailed = 0;
        ratifyAPIResponse.data.forEach((ratifyAPIResponseData) => {
          if (ratifyAPIResponseData.walletTypeId === template?.publicCardWalletTypeId && !ratifyAPIResponseData?.allowed) {
            isRatifyFailed = isRatifyFailed + 1;
          }
          if (ratifyAPIResponseData.walletTypeId === template?.publicCloseLoopWalletTypeId && !ratifyAPIResponseData?.allowed) {
            isRatifyFailed = isRatifyFailed + 1;
          }
        });

        setRatify(isRatifyFailed <= 0);
      }
      setLoading(false);
      if (ratifyAPIResponse.data && ratifyAPIResponse.data.length < 1) {
        showAlert(true, 'ERROR', `Ratify details not found!`);
      }
      getDocuments();
    }).catch((error) => {
      setLoading(false);
      if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
        showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
      } else {
        redirectToErrorScreen('/pages/user', '/pages/error');
      }
    });
  }, [tenantId, customer, template, redirectToErrorScreen, getDocuments]);

  const doRatifyKYC = () => {
    if (template?.ratifyTrialCount > 2) {
      history.push({
        pathname: `/pages/contact-support`
      });
    } else {
      history.push({
        pathname: `/pages/identity-document`,
        state: { fromScreen: "USER_PROFILE", isAddressAdded: addresses.length > 0 }
      });
    }
  }

  const handleEditTitleEmailFormSubmit = useCallback((controlName) => {
    const validationErrors = validateEditTitleEmailForm(inputs, controlName);
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors(validationErrors);
    if (noErrors) {
      if ((inputs?.email !== customer?.email) || (inputs?.title !== customer?.title)) {
        setProfileLoading(true);
        const customerAPI = new DCustomerManagementApi();
        const customerBody = {
          ...customer,
          email: inputs?.email,
          title: inputs?.title
        };
        customerAPI.tenantsTenantIdCustomersCustomerIdPut(tenantId, customer?.customerId, customerBody).then((customerApiResponse) => {
          setProfileLoading(false);
          setEditTitle(false);
          setEditEmail(false);
          props.appData.customer = customerApiResponse?.data;
          props.appData.isRefresh = true;
          props.userProfileHandler({ ...props.appData });
        }).catch((error) => {
          setProfileLoading(false);
          if (error instanceof Error && error.response && error.response.data && error.response.data.length > 0 && error.response.data[0].description) {
            showAlert(true, 'ERROR', `${error.response.data[0].code} :: ${error.response.data[0].description}`);
          } else {
            redirectToErrorScreen('/pages/dashboard', '/pages/error');
          }
        });
      }
    }
  }, [customer, inputs, props, tenantId, redirectToErrorScreen]);

  React.useEffect(() => {
    if (isKYCRequired && !appData?.isRefresh) {
      getRatify();
    }
  }, [getRatify, isKYCRequired, appData]);

  React.useEffect(() => {
    return () => {
      window.onpopstate = () => {
        backToHome();
      }
    };
  }, [history, backToHome])

  React.useEffect(() => {
    (async () => {
      setLoading(true);
      setIsWebAuthNAvailable(await platformAuthenticatorIsAvailable());
      await getLoginChallenge(`${identityPrefix}WEBAUTH-${userIdentity}`).then(response => {
        setActive(!!response.publicKey);
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      })
    })();
  }, [identityPrefix, userIdentity]);

  return (
    <div>
      <SpinnerComponent loading={isLoading || isProfileLoading} position="global" color={primaryColor} />
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12} style={{ display: 'flex' }}>
              <ArrowBackIosIcon className={classes.linkColor} onClick={backToHome} />
              <span className={classes.title}>{isKYCRequired ? 'Profile' : 'Settings'}</span>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
      {isKYCRequired ?
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <h4 className='m-b-0'><b>Hi {customer?.firstName}, <br /> here's your personal details.</b></h4>
          </GridItem>
          {isLoading ? null :
            <>
              <GridItem xs={12} sm={12} md={12}>
                <h6 className='m-b-0 m-t-0' style={{ textTransform: 'none' }}><b>Your identity verification status</b></h6>
                <span style={{ display: 'flex' }}>
                  {isRatifiedSuccess ? <CheckCircleOutlineOutlinedIcon className={classes.iconSuccess} /> :
                    <CancelOutlinedIcon className={classes.iconDanger} />}
                  {isRatifiedSuccess ?
                    <p className={classes.textLeft} style={{ margin: '10px 0 10px 15px' }}>KYC completed</p>
                    : <p className={classes.textLeft} style={{ margin: '10px 0 10px 15px' }}>KYC Not completed</p>
                  }
                </span>
              </GridItem>
              {!isRatifiedSuccess || (isRatifiedSuccess && postSuccessKYCProcessEnable) ?
                <GridItem xs={12} sm={12} md={12}>
                  <Button className={classes.buttonRadius} size="lg" block color="transparent" onClick={doRatifyKYC}>Do
                    Ratify</Button>
                </GridItem>
                : null}
            </>
          }
          <GridItem xs={12} sm={12} md={12}>
            <p style={{ display: 'flex' }}>
              <b style={{ paddingTop: '7px' }}>Enable biometric login</b>
              <span style={{ paddingTop: 7, marginLeft: "auto" }}>
                <Tooltip enterTouchDelay={0} title="You can only sign in with biometrics on devices activated by your fingerprint or face recognition." aria-label="add">
                  <ToolTipIcon fill={primaryIconColor} />
                </Tooltip>
              </span>
            </p>
            <div style={{ display: 'flex' }}>
              <FormControlLabel
                style={{ marginLeft: "0px" }}
                control={<IOSSwitch name="checkedB" checked={isActive} onChange={toggleChecked} />}
                label={""} />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <h6 className='m-b-0 m-t-0' style={{ textTransform: 'none' }}><b>Your personal details</b></h6>
            <ul style={{ padding: '0', listStyle: 'none' }}>
              {editTitle ?
                <li style={{ margin: '0 0 10px 0' }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <ValidationTextField
                            fullWidth
                            label="Title"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            select
                            variant="filled"
                            id="title"
                            type="text"
                            error={!!(errors?.title)}
                            name="title"
                            value={inputs?.title || ''}
                            onChange={handleInputChange}
                            onKeyUp={handleInputKeyUp}>
                            {titleEnumList?.map((data, index) => {
                              return (<MenuItem key={index} value={data}>{data}</MenuItem>)
                            })}
                          </ValidationTextField>
                          {errors?.title && <Danger><small>{errors?.title}</small></Danger>}
                        </GridItem>
                        <GridItem xs={6} sm={6} md={6}>
                          <Button className={classes.buttonRadius} size="sm" block color="transparent"
                            onClick={() => {
                              cancelChanges('title');
                            }}>Cancel</Button>
                        </GridItem>
                        <GridItem xs={6} sm={6} md={6}>
                          <Button className={classes.buttonRadius} size="sm" block color="primary" type="button"
                            onClick={() => {
                              handleEditTitleEmailFormSubmit('title')
                            }}
                            disabled={!!errors?.title || inputs?.title === customer?.title}>Save</Button>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </li> : <li style={{ margin: '0 0 10px 0' }}>
                  <span className={classes.labelText}>Title<EditIcon style={{ float: 'right' }}
                    className={classes.linkColor} onClick={() => {
                      setEditTitle(true)
                    }} /></span>
                  <p className='m-t-0 m-b-0'>{customer?.title}</p>
                </li>}
              <li style={{ margin: '0 0 10px 0' }}>
                <span className={classes.labelText}>Full name</span>
                <p className='m-t-0 m-b-0'>
                  {customer?.firstName} {customer?.middleName} {customer?.lastName}
                </p>
              </li>
              <li style={{ margin: '0 0 10px 0' }}>
                <span className={classes.labelText}>Contact number</span>
                <p className='m-t-0 m-b-0'>{customer?.phone1}</p>
              </li>
              {editEmail ?
                <li style={{ margin: '0 0 10px 0' }}>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <ValidationTextField
                            fullWidth
                            label="Email address"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            variant="filled"
                            id="email"
                            type="text"
                            error={!!(errors?.email)}
                            name="email"
                            value={inputs?.email || ''}
                            onChange={handleInputChange}
                            onKeyUp={handleInputKeyUp} />
                          {errors?.email && <Danger><small>{errors?.email}</small></Danger>}
                        </GridItem>
                        <GridItem xs={6} sm={6} md={6}>
                          <Button className={classes.buttonRadius} size="sm" block color="transparent"
                            onClick={() => {
                              cancelChanges('email');
                            }}>Cancel</Button>
                        </GridItem>
                        <GridItem xs={6} sm={6} md={6}>
                          <Button className={classes.buttonRadius} size="sm" block color="primary" type="button"
                            onClick={() => {
                              handleEditTitleEmailFormSubmit('email')
                            }}
                            disabled={!!errors?.email || inputs?.email === customer?.email}>Save</Button>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </li>
                : <li style={{ margin: '0 0 10px 0' }}>
                  <span className={classes.labelText}>Email Address<EditIcon style={{ float: 'right' }}
                    className={classes.linkColor}
                    onClick={() => {
                      setEditEmail(true)
                    }} /></span>
                  <p className='m-t-0 m-b-0'>{customer?.email}</p>
                </li>}
              <li style={{ margin: '0 0 10px 0' }}>
                <span className={classes.labelText}>ID/Passport number</span>
                <p
                  className='m-t-0 m-b-0'>{customer?.nationalIdentityNumber ? customer?.nationalIdentityNumber : customer?.passportNumber}</p>
              </li>
              <li style={{ margin: '0 0 10px 0' }}>
                <span className={classes.labelText}>Gender</span>
                <p className='m-t-0 m-b-0'>{customer?.gender}</p>
              </li>
              <li style={{ margin: '0 0 10px 0' }}>
                <span className={classes.labelText}>Date of birth</span>
                <p
                  className='m-t-0 m-b-0'>{customer?.dateOfBirth ? customer?.dateOfBirth.substr(6, 2) + '-' + customer?.dateOfBirth.substr(4, 2) + '-' + customer?.dateOfBirth.substr(0, 4) : null}</p>
              </li>
              {addresses && addresses.length > 0 ? addresses.map((address) => {
                return (<li style={{ margin: '0 0 10px 0' }} key={address?.addressId}>
                  <span className={classes.labelText}>Address({address?.addressType}) #{address?.addressId}</span>
                  <p className='m-t-0 m-b-0'>{address?.line1}</p>
                  <p className='m-t-0 m-b-0'>{address?.line2}</p>
                  <p className='m-t-0 m-b-0'>{address?.line3}</p>
                  <p className='m-t-0 m-b-0'>{address?.city} - {address?.state}</p>
                  <p className='m-t-0 m-b-0'>{address?.country} - {address?.code}</p>
                </li>)
              }) : null}
            </ul>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <h6 className='m-b-0 m-t-0' style={{ textTransform: 'none' }}><b>Your KYC Documents</b></h6>
            <GridContainer>
              {documents && documents.length > 0 ? documents.map((document) => {
                if (!document?.documentType.includes('COMPARISON')) {
                  return (<GridItem xs={6} sm={6} md={6} key={document?.documentId}>
                    <div className='docBox'>
                      <img src={'data:' + document?.mediaType + ';base64,' + document?.base64EncodedDocument} alt='' />
                    </div>
                  </GridItem>)
                }
                return ("");
              }) : null}
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <Button className={classes.buttonRadius} size="lg" block color="transparent"
                  onClick={redirectToChangePasswordPIN}>Change {passwordPINText}</Button>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <Button className={classes.buttonRadius} size="lg" block color="transparent"
                  onClick={deactivateAccount}>Deactivate Account</Button>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <Button className={classes.buttonRadius} size="lg" block color="primary" onClick={logout}>Logout</Button>
          </GridItem>
        </GridContainer>
        :
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <h6 className='m-b-0 m-t-0' style={{ textTransform: 'none' }}><b>Your account details</b></h6>
            <ul style={{ padding: '0', listStyle: 'none' }}>
              <li style={{ margin: '0 0 10px 0' }}>
                <span className={classes.labelText}>
                  Your number
                  <Button
                    style={{ boxShadow: 'none', borderStyle: 'none', padding: '0', margin: '0', marginLeft: '0.5em' }}
                    aria-describedby={popoverId} variant="contained" color="transparent" onClick={handlePopoverClick}>
                    <Info />
                  </Button>
                  <Popover style={{ maxWidth: '25em' }} id={popoverId} open={popoverOpen} anchorEl={popoverAnchorEl}
                    onClose={handlePopoverClose}
                    anchorOrigin={{
                      vertical: 'center',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'center',
                      horizontal: 'left',
                    }}
                  >
                    <p style={{
                      textAlign: 'right',
                      padding: '0.5em 1em',
                      margin: '0',
                      color: primaryColor,
                      cursor: 'pointer'
                    }} onClick={handlePopoverClose}><b>x</b></p>
                    <Typography className={classesPopOver.typography}>
                      Your account is associated with your mobile number and therefor can not be edited. If your number change, please register a new account.
                    </Typography>
                  </Popover>
                </span>
                <p className='m-t-0 m-b-0'>{customer?.phone1}</p>
              </li>
            </ul>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{
            paddingTop: '0px',
            marginBottom: '0px',
            borderBottomWidth: '1',
            borderBottomStyle: 'solid ',
            borderBottomColor: grayColor[0]
          }}>
            <p className={classes.regularFontSize} style={{ color: { primaryColor } }}><span
              className={classes.linkColor} onClick={logout}>Log off</span></p>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{
            paddingTop: '0px',
            marginBottom: '0px',
            borderBottomWidth: '1',
            borderBottomStyle: 'solid ',
            borderBottomColor: grayColor[0]
          }}>
            <p className={classes.regularFontSize} style={{ color: { primaryColor } }}><span
              className={classes.linkColor} onClick={redirectToChangePasswordPIN}>Change {passwordPINText}</span></p>
          </GridItem>
        </GridContainer>
      }

      {alertData?.isAlertDisplay ? <AlertNotification alertData={alertData} /> : null}
      <Dialog open={confirmOpen}>
        <div style={{ float: 'left', width: '100%', padding: '20px', boxSizing: 'border-box' }}>
          <p className={classes.regularFontSize + ' ' + classes.textLeft + ' m-t-0'}><b>You are about to deactivate your
            account.</b></p>
          <p className={classes.regularFontSize + ' ' + classes.textLeft + ' m-t-0'}>Your account will be deactivated
            and can be reactivated at any time.</p>
          <span style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 0 0 0' }}>
            <strong className={classes.linkColor} onClick={() => {
              setActive(isActive ? false : true);
              handleClose();
            }}>Cancel</strong> &nbsp;&nbsp;
            <strong className={classes.linkColor} onClick={handleDeactivate}>Deactivate account</strong>
          </span>
        </div>
      </Dialog>
      {/* webAuthN not sipported dialog */}

      <Dialog open={openWebAuthnSupportDialog}>
        <div style={{ float: 'left', width: '100%', padding: '20px', boxSizing: 'border-box' }}>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}><span><BiometricErrorIcon /></span></p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}><b>Your device does not support biometric sign-in</b></p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>Please use your password to sign in.</p>
          <span style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 0 0 0' }}>
            <strong className={classes.linkColor} onClick={closeDialog}>OK</strong> &nbsp;&nbsp;
          </span>
        </div>
      </Dialog>
      <Dialog open={openWebAuthnConfirmDialog}>
        <div style={{ float: 'left', width: '100%', padding: '20px', boxSizing: 'border-box' }}>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>
            <span><BiometricErrorIcon /></span>
          </p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}><b>{`Are you sure you want to ${webauthnActivate ? 'activate' : 'deactivate'} biometric sign-in on this device?`}</b></p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>{`You will ${webauthnActivate ? 'only' : 'not'} be able to sign in on this specific device and not on other devices.`}</p>
          <p style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 0 0 0' }}>
            <span style={{ margin: '0 20px 0 0' }}>
              <strong className={classes.linkColor} onClick={closeDialog}>Cancel</strong>
            </span>
            <span>
              <strong className={classes.linkColor} onClick={webauthnActivate ? activateWebauthn : removeWebAuthIdentity}>Yes</strong>
            </span>
          </p>
        </div>
      </Dialog>
      <Dialog open={openWebAuthnErrorDialog}>
        <div style={{ float: 'left', width: '100%', padding: '20px', boxSizing: 'border-box' }}>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>
            <span><BiometricErrorIcon /></span>
          </p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>
            <b>We can't verify your identity</b>
          </p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>
            Your device's biometrics can't verify your identity.Try signing in with your {passwordPINText}.
          </p>
          <span style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 0 0 0' }}>
            <strong className={classes.linkColor} onClick={closeDialog}>Done</strong> &nbsp;&nbsp;
          </span>
        </div>
      </Dialog>
      <Dialog open={openWebAuthnRegisterErrorDialog}>
        <div style={{ float: 'left', width: '100%', padding: '20px', boxSizing: 'border-box' }}>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>
            <span><BiometricErrorIcon /></span>
          </p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>
            <b>Your Biometric not enabled</b>
          </p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>
            Please signing in with your {passwordPINText} and enable your biometric from profile.
          </p>
          <span style={{ display: 'flex', justifyContent: 'flex-end', margin: '20px 0 0 0' }}>
            <strong className={classes.linkColor} onClick={closeDialog}>Done</strong> &nbsp;&nbsp;
          </span>
        </div>
      </Dialog>
      <Dialog open={openWebAuthnSuccessDialog}>
        <div style={{ float: 'left', width: '100%', padding: '20px', boxSizing: 'border-box' }}>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}><span><BiometricSuccessIcon /></span></p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}><b>You can now sign in using your biometrics on this device</b></p>
          <p className={classes.regularFontSize + ' ' + classes.textCenter + ' m-t-0'}>You can manage your biometric sign-in in your profile.</p>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Button className={classes.buttonRadius} size="lg" block color="primary" onClick={backToHome}
                type="button">Done</Button>
            </GridItem>
          </GridContainer>
        </div>
      </Dialog>
      {/* webAuthN not sipported dialog */}
    </div>
  );
}

const mapStateToProps = state => ({
  appData: state.applicationData.appData
})

const mapDispatchToProps = dispatch => ({
  logoutFromAppHandler: data => dispatch(logoutFromApp(data)),
  userProfileHandler: data => dispatch(loginToApp(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile)